import { FC, useRef } from "react";
import { Fragment } from "react/jsx-runtime";
import SunEditor from "suneditor-react"; // hoặc import từ nơi bạn khai báo interface
import 'suneditor/dist/css/suneditor.min.css';
import AppAlert from "./AppAlert";
import Content from "layouts/admin/pages/library/Content";
import { apiFileUpload, FileItemProps, FolderItemProps } from "apis";
import plugins from "suneditor/src/plugins";
import useAppSelector from "hooks/useAppSelector";
const vi = {
    code: "vi",
    toolbar: {
        default: "Mặc định",
        save: "Lưu",
        font: "Phông chữ",
        formats: "Định dạng",
        fontSize: "Cỡ chữ",
        bold: "Đậm",
        underline: "Gạch chân",
        italic: "Nghiêng",
        strike: "Gạch ngang",
        subscript: "Chỉ số dưới",
        superscript: "Chỉ số trên",
        removeFormat: "Xóa định dạng",
        fontColor: "Màu chữ",
        hiliteColor: "Màu nền",
        indent: "Tăng lề",
        outdent: "Giảm lề",
        align: "Căn lề",
        alignLeft: "Trái",
        alignRight: "Phải",
        alignCenter: "Giữa",
        alignJustify: "Đều",
        list: "Danh sách",
        orderList: "Số thứ tự",
        unorderList: "Chấm đầu dòng",
        horizontalRule: "Đường kẻ ngang",
        hr_solid: "Đường liền",
        hr_dotted: "Đường chấm",
        hr_dashed: "Đường gạch",
        table: "Bảng",
        link: "Liên kết",
        math: "Công thức",
        image: "Hình ảnh",
        video: "Video",
        audio: "Âm thanh",
        fullScreen: "Toàn màn hình",
        showBlocks: "Hiện khối",
        codeView: "Xem mã",
        undo: "Hoàn tác",
        redo: "Làm lại",
        preview: "Xem trước",
        print: "In",
        tag_p: "Đoạn",
        tag_div: "DIV",
        tag_h: "Tiêu đề",
        tag_blockquote: "Trích dẫn",
        tag_pre: "Mã code",
        template: "Mẫu",
        lineHeight: "Chiều cao dòng",
        paragraphStyle: "Kiểu đoạn",
        textStyle: "Kiểu chữ",
        imageGallery: "Thư viện ảnh",
        dir_ltr: "Trái sang phải",
        dir_rtl: "Phải sang trái",
        mention: "Nhắc đến"
    },
    dialogBox: {
        linkBox: {
            title: "Chèn liên kết",
            url: "Đường dẫn",
            text: "Văn bản",
            newWindowCheck: "Mở trong tab mới",
            downloadLinkCheck: "Tải xuống",
            bookmark: "Bookmark"
        },
        mathBox: {
            title: "Công thức toán học",
            inputLabel: "Mã LaTeX",
            fontSizeLabel: "Cỡ chữ",
            previewLabel: "Xem trước"
        },
        imageBox: {
            title: "Chèn hình ảnh",
            file: "Tệp",
            url: "Địa chỉ",
            altText: "Văn bản thay thế"
        },
        videoBox: {
            title: "Chèn video",
            file: "Tệp",
            url: "Địa chỉ"
        },
        audioBox: {
            title: "Chèn âm thanh",
            file: "Tệp",
            url: "Địa chỉ"
        },
        browser: {
            tags: "Thẻ",
            search: "Tìm kiếm"
        },
        caption: "Chú thích",
        close: "Đóng",
        submitButton: "Xác nhận",
        revertButton: "Hoàn tác",
        proportion: "Tỉ lệ",
        basic: "Cơ bản",
        left: "Trái",
        right: "Phải",
        center: "Giữa",
        width: "Chiều rộng",
        height: "Chiều cao",
        size: "Kích thước",
        ratio: "Tỷ lệ"
    },
    controller: {
        edit: "Chỉnh sửa",
        unlink: "Bỏ liên kết",
        remove: "Xóa",
        insertRowAbove: "Chèn dòng phía trên",
        insertRowBelow: "Chèn dòng phía dưới",
        deleteRow: "Xóa dòng",
        insertColumnBefore: "Chèn cột bên trái",
        insertColumnAfter: "Chèn cột bên phải",
        deleteColumn: "Xóa cột",
        fixedColumnWidth: "Cố định độ rộng",
        resize100: "100%",
        resize75: "75%",
        resize50: "50%",
        resize25: "25%",
        autoSize: "Tự động",
        mirrorHorizontal: "Lật ngang",
        mirrorVertical: "Lật dọc",
        rotateLeft: "Xoay trái",
        rotateRight: "Xoay phải",
        maxSize: "Kích thước tối đa",
        minSize: "Kích thước tối thiểu",
        tableHeader: "Tiêu đề bảng",
        mergeCells: "Gộp ô",
        splitCells: "Tách ô",
        HorizontalSplit: "Tách ngang",
        VerticalSplit: "Tách dọc"
    },
    menu: {
        spaced: "Cách đều",
        bordered: "Viền",
        neon: "Neon",
        translucent: "Trong suốt",
        shadow: "Đổ bóng",
        code: "Mã"
    }
};

interface AdminEditorProps {
    value?: string;
    onChange?: (content: string) => void;
}
const AdminEditor: FC<AdminEditorProps> = ({ value, onChange }) => {

    const config = useAppSelector(state => state.config);
    const myGallery = {
        name: "myGallery",
        display: "command",
        title: "Thư viện",
        buttonClass: "",
        innerHTML: "<i class='fa-solid fa-folder-open'></i>",
        add: function () { }, // bắt buộc có

        action: function () {
            const modalInstance = AppAlert.modal({
                title: "Thư viện",
                fullWidth: true,
                fullHeight: true,
                content: <Fragment>
                    <FileSelectModalContent
                        onSelect={(file) => {
                            editorRef.current.insertHTML(`<img src="${file.path}" alt="${file.name}" />`);
                        }}
                        onClose={() => modalInstance.close()}
                    />
                </Fragment>
            });
        }
    };
    const editorRef = useRef<any>(null);
    return <Fragment>
        <SunEditor
            getSunEditorInstance={(sunEditor) => {
                // lưu instance gốc
                editorRef.current = sunEditor;
            }}
            lang={vi}
            setContents={value || ''}
            onChange={onChange}
            setOptions={{
                height: "300px",
                font: [
                    "Arial", "Comic Sans MS", "Courier New", "Impact", "Georgia", "Tahoma", "Trebuchet MS", "Verdana",
                    "Lexend", "Nunito" // ✅ thêm vào danh sách font
                ],
                defaultStyle: "font-family: 'Nunito', sans-serif; font-size: 14px;", // ✅ đặt font mặc định
                buttonList: [
                    ['undo', 'redo'],
                    ['bold', 'underline', 'italic', 'strike'],
                    ['font', 'fontSize', 'formatBlock',],
                    ['fontColor', 'hiliteColor'],
                    ['align', 'list', 'table', 'link', 'image', 'video', 'codeView', 'fullScreen'],
                    ['myGallery']
                ],
                plugins: {
                    ...plugins,
                    myGallery,
                },
            }}
            onImageUploadBefore={(files, info, uploadHandler) => {
                setTimeout(async () => {
                    try {
                        const res = await apiFileUpload({ files: files as any, folderId: config.editorUploadFolderId });

                        if (res.status && res.data?.list[0]) {
                            const file = res.data?.list[0];
                            uploadHandler({
                                result: [
                                    {
                                        url: `${process.env.REACT_APP_FILE_URL}${file.path}`,
                                        name: file.name,
                                        size: file.size,
                                    },
                                ],
                            });
                        }
                        else {
                            uploadHandler({
                                result: [],
                                errorMessage: "Lỗi"
                            });
                        }
                    } catch (e) {
                        uploadHandler({
                            result: [],
                            errorMessage: "Lỗi"
                        });
                    }
                });
                return false;
            }}
            onVideoUploadBefore={(files, info, uploadHandler) => {
                setTimeout(async () => {
                    try {
                        const res = await apiFileUpload({ files: files as any, folderId: config.editorUploadFolderId });

                        if (res.status && res.data?.list[0]) {
                            const file = res.data?.list[0];
                            uploadHandler({
                                result: [
                                    {
                                        url: `${process.env.REACT_APP_FILE_URL}${file.path}`,
                                        name: file.name,
                                        size: file.size,
                                    },
                                ],
                            });
                        }
                        else {
                            uploadHandler({
                                result: [],
                                errorMessage: "Lỗi"
                            });
                        }
                    } catch (e) {
                        uploadHandler({
                            result: [],
                            errorMessage: "Lỗi"
                        });
                    }
                });
                return false;
            }}
        />
    </Fragment>
}
export default AdminEditor;

type FileSelectModalContentProps = { onClose?: () => void; onSelect: (file: FileItemProps) => void; }
const FileSelectModalContent: FC<FileSelectModalContentProps> = ({ onSelect, onClose }) => {

    return (
        <>
            <Content
                minType={["image", "video"]}
                allowSelectFolder={false}
                onDoubleClickFile={(file) => {
                    onSelect(file);
                    onClose?.();
                }}
            />
        </>
    );
}